module.exports = __webpack_public_path__ + "static/img/news.aa2c030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/news.jpg
// module id = aq+m
// module chunks = 1